/**
 * StatisticMenu
 * --
 */
import React from 'react';
import { Descriptions, Table, Button, Input, Space } from 'antd';
import { Content, Title, Row, Col } from 'components';
import moment from 'moment';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import { SearchOutlined } from '@ant-design/icons';
// import { downloadXlsx } from 'utils/XlsxDownloader';
import * as XLSX from 'xlsx/xlsx.mjs';

/* 

메뉴별 매출 : 사용중인 필드
  menu: 메뉴명
  totalAmount: 합계금액
  netSales: 순매출
  paymentsCount: 판매수량
  couponAppliedCount: 쿠폰사용수량
  discountAmount: 쿠폰사용금액
*/
const SEARCH_KEYWORD = {
  product_category_name: null,
};
/**----------------------------------------
 * [Component] 메뉴별 매출
 * ----------------------------------------
 */
const StatisticMenu = ({
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  data, // 차트 데이터
  startDate,
  endDate,
  dateRange,
  // onSelect,
  finalDiscount,
  finalUsePoint,
  menuCoupon,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [searchValue, setSearchValue] = React.useState(SEARCH_KEYWORD);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(30);
  /* ===== VARIABLE ===== */
  // const currentShopInfo = shopList.filter(({ key }) => key === currentShop)[0];
  const columns = [
    {
      title: '메뉴명',
      dataIndex: 'menu_name',
      width: 330,
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={searchValue?.menu_name}
            onChange={(e) => handleChange('menu_name', e.target.value)}
            onPressEnter={() => confirm()}
            placeholder={`메뉴명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                handleChange('menu_name', null);
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
      // fixed: 'left',
    },
    {
      title: '총매출',
      dataIndex: 'totalAmount',
      width: 160,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.totalAmount - b.totalAmount,
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          순매출
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출-할인)
          </span>
        </span>
      ),
      dataIndex: 'salesAmount',
      width: 160,
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(
            Number(record.totalAmount) - Number(record.discountAmount),
          )}
        </div>
      ),
      sorter: (a, b) => {
        const aa = Number(a.totalAmount) - Number(a.discountAmount);
        const bb = Number(b.totalAmount) - Number(b.discountAmount);
        return aa - bb;
      },
    },
    {
      title: <span style={{ lineHeight: 0.5 }}>단가</span>,
      dataIndex: 'menu_price',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.menu_price - b.menu_price,
    },
    {
      title: <span style={{ lineHeight: 0.5 }}>메뉴판매량</span>,
      dataIndex: 'menu_count',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.menu_count - b.menu_count,
    },
    {
      title: '할인',
      dataIndex: 'discountAmount',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.discountAmount - b.discountAmount,
    },
    {
      title: '쿠폰',
      dataIndex: 'coupon_count',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.coupon_count - b.coupon_count,
    },
    // {
    //   title: '쿠폰할인',
    //   dataIndex: 'counponDiscount',
    //   width: 100,
    //   render: (v) => (
    //     <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
    //   ),
    // },

    // REVIEW - 데이터가 집계되지 않아 숨김처리함.
    // {
    //   title: '환불금액',
    //   dataIndex: 'refundAmount',
    //   width: 150,
    //   render: (v) => (
    //     <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
    //   ),
    // },
    // {
    //   title: '환불건수',
    //   dataIndex: 'refundCount',
    //   width: 150,
    //   render: (v) => (
    //     <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
    //   ),
    // },
  ];
  /* ===== FUNCTION ===== */
  /**
   *
   * --
   */
  const handleCalculate = (d, key) => {
    if (!d || d.length < 1) {
      return 0;
    }
    return d.reduce((acc, cur) => acc + Number(cur[key] ?? 0), 0);
  };
  /**
   * 페이지 네이션 함수
   * @param {number} page
   * --
   */
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  /**
   * 엑셀 다운로드
   * --
   */
  const handleDownloadExel = () => {
    try {
      const newList = [
        ...newDataList,
        {
          menu_name: '포인트 사용 금액',
          discountAmount: finalUsePoint2,
          coupon_count: 0,
          totalAmount: 0,
          menu_count: 0,
          menu_price: 0,
        },
      ];

      const xlsxData = newList?.map((item, idx) => {
        return {
          순번: idx + 1,
          메뉴명: item.menu_name,
          총매출: Number(item.totalAmount),
          순매출: Number(item.totalAmount) - Number(item.discountAmount),
          단가: Number(item.menu_price ?? 0),
          메뉴판매량: Number(item.menu_count ?? 0),
          할인:
            item?.menu_name === '포인트 사용 금액'
              ? 0
              : Number(item.discountAmount ?? 0),
          쿠폰주문: Number(item.coupon_count ?? 0),
          // ['쿠폰할인']: Number(item.counponDiscount ?? 0),
          // ['환불금액']: Number(item.refundAmount ?? 0),
          // ['환불건수']: Number(item.refundCount ?? 0),
        };
      });

      const ws = XLSX.utils.json_to_sheet(xlsxData);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(
        wb,
        `메뉴별 매출_${moment().format('YYYYMMDDHHmmss')}.xlsx`,
      );
    } catch (e) {
      console.log(e);
      MessageAlert.error(e.message);
    }
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */

  // 신규데이터

  const newData =
    data &&
    menuCoupon &&
    data.map((item) => {
      const ff = menuCoupon.find((m) => m.menu_name === item.menu_name);
      return {
        ...item,
        coupon_count: ff?.coupon_count ?? 0,
        discountAmount: ff?.discountAmount ?? 0,
      };
    });
  // 기간내 할인금액 => order 테이블의 final_discount
  const finalDiscount2 = Math.abs(Number(finalDiscount));
  const finalUsePoint2 = Math.abs(Number(finalUsePoint));
  const couponDiscountAmount = handleCalculate(newData, 'discountAmount');
  let diffDiscount = finalDiscount2 - couponDiscountAmount;

  const newDataWithPosDiscount = React.useMemo(() => {
    return newData
      ? [
          ...newData,
          {
            menu_name: '포스 할인금액',
            discountAmount: diffDiscount,
            coupon_count: 0,
            totalAmount: 0,
            menu_count: 0,
            menu_price: 0,
          },
        ]
      : [];
  }, [newData, diffDiscount]);

  const newDataList = React.useMemo(() => {
    let arr = newDataWithPosDiscount;
    const { menu_name } = searchValue;
    if (menu_name) {
      arr = arr?.filter((item) => item.menu_name.includes(menu_name));
    }
    return arr;
  }, [searchValue, newDataWithPosDiscount]);

  /**
   * 데이터 바인팅
   * --
   * @param {string} t
   * @param {string | number} v
   */
  const handleChange = (t, v) => {
    setSearchValue((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          {/* === 상단 > 타이틀 === */}
          <Col x={12} style={{ display: 'flex', gap: 10 }}>
            <Title style={{ marginBottom: 7.5 }}>
              메뉴별 리포트
              {/* {/* {currentShopInfo && `(${currentShopInfo.shop_information_name})`} */}
            </Title>
            <Button onClick={() => handleDownloadExel()}>
              엑셀로 다운로드
            </Button>
          </Col>
          <Col x={12} style={{ textAlign: 'right' }}>
            <Title
              level={5}
              align="right"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 7.5,
              }}
            >
              <small>조회기간:</small>&nbsp;&nbsp;
              {!dateRange.startDate || !dateRange.endDate ? (
                <>
                  {moment(startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(endDate).format('YYYY.MM.DD(ddd)')}
                </>
              ) : (
                <>
                  {moment(dateRange.startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(dateRange.endDate).format('YYYY.MM.DD(ddd)')}
                </>
              )}
            </Title>
          </Col>
        </Row>
        <div style={{ background: '#fff' }}>
          {newDataList && (
            <Descriptions
              // title="User Info"
              className="boxShadow"
              size="small"
              layout="vertical"
              column={15}
              bordered
              style={{ width: '100%' }}
              // labelStyle={{ width: 135 }}
              contentStyle={{ textAlign: 'right' }}
              items={[
                {
                  key: 'date',
                  label: '',
                  contentStyle: { textAlign: 'center' },
                  style: { width: 330 },
                  children: <p>합계</p>,
                },
                {
                  key: 'totalAmount',
                  label: <span style={{ lineHeight: 0.5 }}>총매출</span>,
                  style: { width: 160 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newDataList, 'totalAmount'),
                      )}
                    </p>
                  ),
                },
                {
                  key: 'netSales',
                  label: (
                    <span style={{ lineHeight: 0.5 }}>
                      순매출
                      <br />
                      <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                        (총매출-할인-포인트)
                      </span>
                    </span>
                  ),
                  style: { width: 160 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newDataList, 'totalAmount') -
                          handleCalculate(newDataList, 'discountAmount') -
                          finalUsePoint2,
                      )}
                    </p>
                  ),
                },
                {
                  key: 'menu_count',
                  label: '메뉴판매량',
                  style: { width: 150 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newDataList, 'menu_count'),
                      )}
                    </p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  style: { width: 150 },
                  children: (
                    <p>
                      -
                      {stringToMoneyFormat(
                        handleCalculate(newDataList, 'discountAmount'),
                      )}
                    </p>
                  ),
                },
                {
                  key: 'finalUsePoint2',
                  label: '사용포인트',
                  style: { width: 150 },
                  children: <p>-{stringToMoneyFormat(finalUsePoint2)}</p>,
                },
                {
                  key: 'coupon_count',
                  // label: '쿠폰주문',
                  label: '사용쿠폰',
                  style: { width: 150 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newDataList, 'coupon_count'),
                      )}
                    </p>
                  ),
                },
                // {
                //   key: 'counponDiscount',
                //   label: '쿠폰할인',
                //   style: { width: 100 },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(newData, 'counponDiscount')
                //       )}
                //     </p>
                //   ),
                // },

                // REVIEW - 데이터가 집계되지 않아 숨김처리함.
                // {
                //   key: 'refundAmount',
                //   label: '환불금액',
                //   style: { width: 150 },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(newData, 'refundAmount')
                //       )}
                //     </p>
                //   ),
                // },

                // {
                //   key: 'refundCount',
                //   label: '환불건수',
                //   style: { width: 150 },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(newData, 'refundCount')
                //       )}
                //     </p>
                //   ),
                // },
              ]}
            />
          )}
        </div>
        <br />

        <div
          style={{
            overflow: 'auto',
            width: '100%',
            height: '100%',
            background: '#fff',
          }}
        >
          {/* {(() => {
            console.log('newData: ', newData);
          })()} */}
          <Table
            className="boxShadow"
            bordered
            size="small"
            dataSource={newDataList}
            columns={columns}
            scroll={{
              x: 'max-content',
            }}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: data?.length,
              showSizeChanger: true,
              pageSizeOptions: ['30', '50', '75', '100'],
              onChange: (page, pageSize) => {
                handlePageChange(page, pageSize);
              },
            }}
            style={{ minHeight: 580, width: 1400 }}
          />
        </div>
      </Content>
    </>
  );
};

export default StatisticMenu;
